import { useContext, useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Loading from '../../../Components/Loading/Loading';
import Pagination from '../../../Components/Pagination/Pagination';
import { useApi } from '../../../Hooks/Api';
import { useRole } from '../../../Hooks/Role';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { dateToJalali } from '../../../Utils/Helpers';
import { CompetitionRegisterContext } from '../Context/CompetitionRegisterContext';

const Competitions = () => {
  const context = useContext(CompetitionRegisterContext);
  const { can, canBoard } = useRole();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { get } = useApi();
  const { error } = useToast();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      if (!can('Super Admin') && !canBoard()) {
        return navigate('/dashboard', {
          replace: true,
        });
      }
      await getCompetitions();
    };
    getData();
  }, [search]);

  const getCompetitions = async () => {
    setLoading(true);
    await get(
      '/competition',
      (res) => {
        context.competitions = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات ناموفق بود لطفا مجددا تلاش کنید.');
        setLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master showSidebar={false} headerFixed={true} containerFullWidth={true}>
      <section className='image-cover'>
        <div className='container'>
          <div className='row pt-5 mx-0 w-100'>
            {context.competitions.length > 0 ? (
              <>
                {context.competitions?.map((competition) => (
                  <div
                    key={competition?.id}
                    className='col-12 col-md-4 my-2 pr-2 overflow-hidden'
                  >
                    <div className='card border rounded overflow-hidden position-relative'>
                      <div className='bg-purple card-bg w-100 p-3 d-flex flex-row justify-content-center'>
                        <span
                          className='text-white f-12 font-weight-bold'
                          style={{ height: '35px' }}
                        >
                          {competition?.title}
                        </span>
                      </div>
                      <div className='card-bg w-100 d-flex flex-row justify-content-center'>
                        <img
                          src={competition?.thumbnail?.path}
                          alt={competition?.title}
                          className='w-100 img-thumbnail'
                          style={{ height: '250px' }}
                        />
                      </div>
                      <div className='card-body p-0 d-flex flex-column justify-content-center w-100 align-items-center'>
                        {moment(
                          competition?.end_register_at ?? '1999-01-01 00:00:00',
                        ).isAfter(moment()) ? (
                          <div className='d-flex flex-column justify-content-center w-100 align-items-center'>
                            {moment(
                              competition?.start_register_at ??
                                '1999-01-01 00:00:00',
                            ).isBefore(moment()) ? (
                              <Link
                                className='btn btn-info w-100 rounded-0 py-3 text-white align-self-end f-14 font-weight-bold my-2'
                                to={`/competition/register/${competition?.slug}`}
                              >
                                ثبت نام در مسابقه
                              </Link>
                            ) : (
                              <Link
                                className='btn btn-info w-100 rounded-0 py-3 text-white align-self-end f-14 font-weight-bold my-2'
                                to='#'
                              >
                                شروع ثبت نام در تاریخ :{' '}
                                {dateToJalali(competition?.start_register_at)}
                              </Link>
                            )}
                          </div>
                        ) : (
                          <button className='btn btn-danger w-100 rounded-0 py-3 text-white align-self-end f-14 font-weight-bold my-2'>
                            پایان ثبت نام
                          </button>
                        )}

                        <div className='d-flex flex-row justify-content-center border w-100 p-2'>
                          <div className='d-flex flex-column border-left w-50 text-center'>
                            <span className='text-dark'>
                              تاریخ شروع ثبت نام
                            </span>
                            <span className='text-dark' dir='ltr'>
                              {dateToJalali(competition?.start_register_at)}
                            </span>
                          </div>
                          <div className='d-flex flex-column w-50 text-center'>
                            <span className='text-dark'>
                              تاریخ پایان ثبت نام
                            </span>
                            <span className='text-dark' dir='ltr'>
                              {dateToJalali(competition?.end_register_at)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {moment(
                      competition?.end_register_at ?? '1999-01-01 00:00:00',
                    ).isBefore(moment()) && (
                      <div class='overflow-hidden card-label'>
                        <span class='bg-danger text-dark-mode f-9 font-weight-bold'>
                          پایان ثبت نام
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </>
            ) : (
              <div className='col-12'>
                <p className='text-dark f-14 bg-white shadow-sm p-4 text-center rounded'>
                  مسابقه ای جهت ثبت نام یافت نشد.
                </p>
              </div>
            )}

            {context.competitions?.meta?.pagination?.total_pages > 1 && (
              <div className='col-12'>
                <div className='w-100 mt-4 d-flex'>
                  <Pagination
                    totalPage={
                      context.competitions?.meta?.pagination?.total_pages
                    }
                    basePath='/competition/register'
                    search={search}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </Master>
  );
};

export default Competitions;
